import { Box, Button, type ButtonProps, Divider, styled, Typography } from '@mui/material';

export const StyledDiv = styled('div')({
  position: 'absolute',
  marginTop: '15%',
  marginLeft: '35%',
});

export const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '11px',
  padding: '2rem',
  textAlign: 'center',
});

export const TitleTypography = styled(Typography)({
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '32px',
  letterSpacing: '0.15px',
});

export const SubtitleTypography = styled(Typography)({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.15px',
});

export const FooterTypography = styled(Typography)({
  fontSize: '14px',
  lineHeight: '19.6px',
  color: 'rgba(86, 101, 115, 1)',
  paddingTop: '2rem',
  a: {
    fontWeight: 700,
    color: 'rgba(4, 128, 211, 1)',
  },
});

const commonButtonStyles = {
  height: '42px',
  borderRadius: '4px',
  fontSize: '15px',
  fontWeight: 600,
  lineHeight: '26px',
  letterSpacing: '0.46px',
};

export const StyledButtonFilled = styled(Button)<ButtonProps>(({ theme }) => ({
  ...commonButtonStyles,
  color: 'rgba(255, 255, 255, 1)',
  backgroundColor: `rgba(0, 0, 0, 1)`,
  width: '230px',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const StyledButtonOutlined = styled(Button)<ButtonProps>(() => ({
  ...commonButtonStyles,
  color: 'rgba(0, 0, 0, 1)',
  border: '1px solid rgba(0, 0, 0, 1)',
  width: '177px',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    border: '1px solid rgba(0, 0, 0, 1)',
  },
}));

export const StyledDivider = styled(Divider)({
  width: '95%',
  marginTop: '1.6rem',
});
